/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import * as Sentry from '@sentry/nextjs';
import { useEffect } from 'react';
import { version } from 'package.json';
import ENV from '~/constants/ENV';
import { useGetUnityConfigQuery } from '~/generated/apollo';
const SentryInit = (): null => {
  const {
    data
  } = useGetUnityConfigQuery({
    variables: {
      input: {
        testcenterid: '00000'
      }
    }
  });
  useEffect(() => {
    const sentryConfig = data?.getUnityConfig.product.attributes?.gatewayAppConfig?.sentry;
    if (sentryConfig) {
      if (sentryConfig.isEnabled) {
        Sentry.init({
          beforeSend(event) {
            const ignoredLevels = sentryConfig.loggedPriorityLevels;
            if (event?.level && ignoredLevels) {
              if (ignoredLevels.includes(event.level)) {
                return null;
              }
            }
            return event;
          },
          debug: true,
          dsn: ENV.SENTRY_DSN,
          environment: ENV.BUILD_ENV,
          release: version,
          sampleRate: 0.3,
          tracesSampleRate: 0.3
        });
      }
    } else if (ENV.SENTRY_ENABLED === 'true') {
      Sentry.init({
        beforeSend(event) {
          const ignoredLevels = ['info', 'debug'];
          if (event?.level) {
            if (ignoredLevels.includes(event.level)) {
              return null;
            }
          }
          return event;
        },
        debug: true,
        dsn: ENV.SENTRY_DSN,
        environment: ENV.BUILD_ENV,
        release: version,
        sampleRate: 0.3,
        tracesSampleRate: 0.3
      });
    }
  }, [data]);
  return null;
};
export default SentryInit;